const COOLDOWN_MS = 30_000; // 30 seconds between submissions

export const canSubmit = (key: string): boolean => {
  const last = localStorage.getItem(`yrd_rate_${key}`);
  if (!last) return true;
  return Date.now() - parseInt(last, 10) >= COOLDOWN_MS;
};

export const recordSubmission = (key: string): void => {
  localStorage.setItem(`yrd_rate_${key}`, Date.now().toString());
};

export const getSecondsRemaining = (key: string): number => {
  const last = localStorage.getItem(`yrd_rate_${key}`);
  if (!last) return 0;
  const elapsed = Date.now() - parseInt(last, 10);
  return Math.max(0, Math.ceil((COOLDOWN_MS - elapsed) / 1000));
};
